export const User = {
  constraints: {},
  email: 'groot-admin@pff.com',
  first_name: 'Groot',
  group_memberships: [],
  groups: [],
  last_name: 'Admin',
  permissions: {},
  preferences: {
    features: '',
  },
  provider: '',
  roles: ['groot-super-admin'],
  subscriptions: [
    {
      end_date: '3000-12-31',
      id: 3,
      roles: ['groot-super-admin'],
      start_date: '2022-02-22',
    },
  ],
  uid: 'a29064db-fa41-448e-90c6-91a1cae1cb8f',
  vertical: 'PFF',
  message: '',
  channel: '',
  product_id: '',
  original_transaction_id: '',
}
